import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Public, unauthenticated landing page. The backend's
 * `GET /courseBundlePackage/payment-link/:token` redeem endpoint redirects
 * here whenever a shared course-purchase payment link is invalid or has
 * passed its short TTL — the payer (parent/sponsor) never logs in, so this
 * page must not sit behind AuthGuardFxn.
 */
@Component({
  selector: 'mindbase-payment-link-expired',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule],
  templateUrl: './payment-link-expired.component.html',
  styleUrl: './payment-link-expired.component.scss'
})
export class PaymentLinkExpiredComponent {}
